import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { IMAGES } from '../utils/constants';
export function ProductPresentation() {
  const scrollToOffer = () => {
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const benefits = ['Giochi di movimento coinvolgenti.', 'Percorsi psicomotori con spiegazioni chiare.', 'Attività pratiche per sviluppare coordinazione, forza e agilità.', 'Lezioni strutturate passo dopo passo.', 'Strumenti di valutazione pronti da utilizzare.', 'Tutto organizzato in modo chiaro e rapido.'];
  return <section className="py-20 px-4 bg-white" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-235">
          {/* Product Image */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-236">
            <div className="relative max-w-md w-full" data-id="element-237">
              <div className="absolute inset-0 bg-blue-100 rounded-full blur-3xl opacity-50 transform scale-90" data-id="element-238"></div>
              <img src={IMAGES.tomo1} alt="Fondamenti dell'Educazione Fisica Moderna" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-239" />
            </div>
          </div>

          {/* Product Details */}
          <div className="w-full lg:w-1/2" data-id="element-240">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-241">
              Mega-Pack <span className="text-blue-600" data-id="element-242">Educazione Fisica</span>
            </h2>
            <p className="text-xl text-gray-600 mb-6 font-medium" data-id="element-243">
              Il sistema completo che ti permette di preparare lezioni
              coinvolgenti in pochi minuti.
            </p>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-244">
              Una raccolta completa di materiali progettati per aiutarti a
              organizzare le lezioni in modo semplice, rapido ed efficace. Con
              questo pacchetto avrai a disposizione centinaia di risorse che
              potrai utilizzare immediatamente in classe.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-245">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-246">
                  <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-247" />
                  <span className="text-gray-800 font-medium text-lg" data-id="element-248">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <button onClick={scrollToOffer} className="w-full sm:w-auto bg-green-500 hover:bg-green-400 text-white font-bold text-lg py-4 px-10 rounded-full shadow-lg transform hover:-translate-y-1 transition-all duration-300 border-b-4 border-green-700" data-id="element-249">
              ACCEDI AL MEGA-PACK
            </button>
          </div>
        </div>
      </div>
    </section>;
}